export function getInitials(fullName: string): string {
  const names = fullName.trim().split(" ");

  if (names.length === 1) {
    return names[0].slice(0, 2).toUpperCase();
  }

  const firstInitial = names[0].charAt(0).toUpperCase();
  const secondInitial = names[1].charAt(0).toUpperCase();

  return `${firstInitial}${secondInitial}`;
}
